import { useApi } from "@/hooks/useApi";
import type { ClubInfo } from "@/lib/types";
import Hero from "./components/Hero";
import LadderBanner from "./components/LadderBanner";
import ScheduleHomeSection from "./components/ScheduleHomeSection";
import IntroSection from "./components/IntroSection";
import BizmapPreview from "./components/BizmapPreview";
import CardSection from "./components/CardSection";
import PromoSection from "./components/PromoSection";
import NoticeSection from "./components/NoticeSection";
import GallerySection from "./components/GallerySection";
import FreeSection from "./components/FreeSection";
import ClubAccountSection from "./components/ClubAccountSection";
import PopupModal from "./components/PopupModal";

export default function Home() {
  const { data: club, loading: clubLoading } = useApi<ClubInfo>("club.php");

  return (
    <>
      <LadderBanner />
      <Hero club={club} />
      <ScheduleHomeSection />
      <IntroSection club={club} loading={clubLoading} />
      <CardSection />
      <BizmapPreview />
      <PromoSection />
      <GallerySection />
      <FreeSection />
      <NoticeSection />
      <ClubAccountSection club={club} />
      <PopupModal popups={club?.popup ?? []} />
    </>
  );
}